<template>
  <div class="modal fade bd-example-modal-xl"
    data-backdrop="static" id="contractDetailModal"
    tabindex="-1" role="dialog" aria-labelledby="contractDetailModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
      <div class="modal-content modal-xl">
        <div class="modal-header">
          <div class="modal-title">
            <h5 class="my-0" id="contractIdModalTitle">Sözleşme Detayı</h5>
            <small class="text-muted my-0">{{contractModel.CustomerTitle}} &bullet; {{contractModel.ContractName}}&nbsp;&nbsp;(Sözleşme No: {{contractModel.ContractId}})</small>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div id="conversation-body-messages" class="modal-body">
          <v-wait for="contract-detail-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Sözleşme detayları yükleniyor...</p>
              </div>
            </template>
            <div class="container-fluid mb-3">
              <div class="form-row mb-3">
                <div class="col-6 pl-0">
                  <label for="contractDate">Sözleşme Tarihi</label>
                  <input type="text" id="contractDate" readonly v-bind:value="contractModel.ContractDate" class="form-control" />
                </div>
                <div class="col-6 pr-0">
                  <label for="personelName">Oluşturan Personel</label>
                  <div class="input-group">
                    <input type="text" id="personelName" readonly v-bind:value="contractModel.PersonelName" class="form-control" />
                    <div class="input-group-append">
                      <button class="btn btn-success" v-if="contractModel.ContractActive == 0">Onayla</button>
                      <button class="btn btn-danger" v-else>Onayı İptal Et</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-6 pl-0">
                  <label for="maxVehicleAllowed">Max. Araç Sayısı</label>
                  <input type="number" id="maxVehicleAllowed" v-model="contractModel.MaxVehicleCount" class="form-control" />
                </div>
                <div class="col-6 pr-0">
                  <label for="vehicleCount">Mevcut Araç Sayısı</label>
                  <input type="number" id="vehicleCount" readonly v-bind:value="contractModel.ActiveVehicleCount" class="form-control" />
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-4 pl-0">
                  <label for="contractStatus">Sözleşme Durumu</label>
                  <select class="form-control" id="contractStatus" v-model="contractModel.Status">
                    <option value="0">Sözleşme Bekleniyor</option>
                    <option value="1">Aktif</option>
                    <option value="2">Donduruldu</option>
                    <option value="3">Fesh</option>
                  </select>
                </div>
                <div class="col-4 pl-0 pr-0">
                  <label for="contractColor">Renk Kodu</label>
                  <select class="form-control" id="contractColor" v-model="contractModel.Color">
                    <option value="white">Beyaz</option>
                    <option value="blue">Mavi</option>
                    <option value="yellow">Sarı</option>
                    <option value="green">Yeşil</option>
                    <option value="black">Kırmızı</option>
                  </select>
                </div>
                <div class="col-4 pr-0">
                  <label for="customerPhone">Firma Telefonu</label>
                  <input type="text" id="customerPhone" readonly v-bind:value="contractModel.CustomerPhone" class="form-control" />
                </div>
              </div>
              <div class="form-row mb-3"></div>
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" id="cdTab1" data-toggle="tab" href="#cdTabContent1" role="tab"
                  aria-controls="cdTabConten1" aria-selected="true">Sözleşme Detayları</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="cdTab2" data-toggle="tab" href="#cdTabContent2" role="tab" aria-controls="cdTabConten2" aria-selected="false">Araçlar</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="cdTab3" data-toggle="tab" href="#cdTabContent3" role="tab" aria-controls="cdTabConten3" aria-selected="false">Faturalar</a>
                </li>
                <li class="nav-item ml-auto">
                  <button class="btn btn-sm btn-success mt-1" type="button" @click="showInvoiceDetails(-1)">
                    <i class="mr-2 fas fa-plus text-white"></i>Yeni Fatura Ekle</button>
                </li>
              </ul>
              <div class="tab-content" id="cdTabContentAll">
                <div class="tab-pane py-4 fade show active" id="cdTabContent1" role="tabpanel" aria-labelledby="cdTabContent1-tab">
                  <div class="form-row mb-4 px-3">
                    <div class="col-4">
                      <label for="contractLength">Sözleşme Süresi</label>
                      <div class="input-group">
                        <input type="number" id="contractLength" v-model="contractModel.ContractLength" class="form-control" />
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1">Ay</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <label for="contractFree">Aidatsız Süre</label>
                      <div class="input-group">
                        <input type="number" id="contractFree" v-model="contractModel.ContractFree" class="form-control" />
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1">Ay</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <label for="unitPrice">Aidat Miktarı</label>
                      <div class="input-group">
                        <input type="number" id="unitPrice" v-model="contractModel.UnitPrice" class="form-control" />
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1">+ KDV</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="form-row mb-4 px-3">
                    <div class="col-3">
                      <label for="gsmEnabled">Hat Dahil</label>
                      <select class="form-control" id="gsmEnabled" v-model="contractModel.GsmEnabled">
                        <option value="0">Hayır</option>
                        <option value="1">Evet</option>
                      </select>
                    </div>
                    <div class="col-3">
                      <label for="blokeEnabled">Bloke Dahil</label>
                      <select class="form-control" id="blokeEnabled" v-model="contractModel.BlokeEnabled">
                        <option value="0">Hayır</option>
                        <option value="1">Evet</option>
                      </select>
                    </div>
                    <div class="col-3">
                      <label for="setupIncluded">Montaj Dahil</label>
                      <select class="form-control" id="setupIncluded" v-model="contractModel.SetupIncluded">
                        <option value="0">Hayır</option>
                        <option value="1">Evet</option>
                      </select>
                    </div>
                    <div class="col-3">
                      <label for="freeInterval">Serbest Takip Süresi</label>
                      <select class="form-control" id="freeInterval" v-model="contractModel.FreeInterval">
                        <option value="0"><i class="fas fa-times mr-2 text-danger"></i>Hayır</option>
                        <option value="1"><i class="fas fa-check mr-2 text-success"></i>Evet</option>
                      </select>
                    </div>
                  </div>
                  <hr />
                  <div class="form-row px-3">
                    <div class="col-4">
                      <label for="unitPrice">Birim Cihaz Bedeli</label>
                      <div class="input-group">
                        <input type="number" id="unitPrice" v-model="contractModel.UnitPrice" class="form-control" />
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1">₺</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <label for="price1">Bloke Kiti Bedeli</label>
                      <div class="input-group">
                        <input type="number" id="price1" v-model="contractModel.Price1" class="form-control" />
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1">₺</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <label for="price4">Montaj Bedeli</label>
                      <div class="input-group">
                        <input type="number" id="price4" v-model="contractModel.Price4" class="form-control" />
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1">₺</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="cdTabContent2" role="tabpanel" aria-labelledby="cdTabContent2-tab">
                  <table class="table table-striped">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col" style="width: 15%">Kayıt No.</th>
                        <th scope="col" style="width: 20%">Kayıt Tarihi</th>
                        <th scope="col" style="width: 40%">Araç Adı</th>
                        <th scope="col" style="width: 25%">Son Veri</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(cdvehicle, index) in contractModel.Vehicles">
                        <tr :key="'cdvehicle-'+index">
                          <td class="align-middle">{{cdvehicle.VehicleId}}</td>
                          <td class="align-middle">{{cdvehicle.Created}}</td>
                          <td class="align-middle">
                            <div class="justify-content-between text-truncate">
                              <p class="my-0 font-semi-bold">{{cdvehicle.VehicleName}}&nbsp;({{cdvehicle.VehicleLicenceTag}})</p>
                              <small class="text-muted">{{cdvehicle.GroupName}} &bullet; {{cdvehicle.DeviceId}}</small>
                            </div>
                          </td>
                          <td class="align-middle">{{cdvehicle.ServerTime}}</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
                <div class="tab-pane fade" id="cdTabContent3" role="tabpanel" aria-labelledby="cdTabContent3-tab">
                  <table class="table table-striped">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col" style="width: 5%">F. No</th>
                        <th scope="col" style="width: 10%">Fatura Tarihi</th>
                        <th scope="col" style="width: 25%">Fatura Açıklaması</th>
                        <th scope="col" style="width: 12%">Fatura Kapsamı</th>
                        <th scope="col" style="width: 10%">Durum</th>
                        <th scope="col" style="width: 10%">Ödenen</th>
                        <th scope="col" style="width: 14%">Kaydeden</th>
                        <th scope="col" style="width: 12%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(invoice, index) in contractModel.Invoices">
                        <tr :key="'invoice-'+index">
                          <td class="align-middle">{{invoice.InvoiceId}}</td>
                          <td class="align-middle">{{invoice.InvoiceDate}}</td>
                          <td class="align-middle">{{invoice.InvoiceTitle}}</td>
                          <td class="align-middle">{{invoice.InvoiceLength}}</td>
                          <td class="align-middle">{{invoice.InvoiceStatus == false ? 'ÖDENMEDİ' : 'ÖDENDİ'}}</td>
                          <td class="align-middle">{{invoice.InvoiceAmount}}</td>
                          <td class="align-middle"><div class="text-truncate">{{invoice.PersonelName}}</div></td>
                          <th class="align-middle">
                            <button role="button" class="btn btn-sm btn-primary" @click="showInvoiceDetails(index)"><i class="far fa-eye text-white"></i></button>
                            <button role="button" class="btn btn-sm btn-danger" @click="deleteInvoice(index)"><i class="far fa-trash-alt text-white"></i> Sil</button>
                          </th>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </v-wait>
        </div>
        <div class="modal-footer">
          <div class="col">
          <button class="btn btn-success float-left clearfix mr-2" type="button">
            <i class="mr-2 fas fa-check text-white"></i>Sözleşmeyi Güncelle</button>
          <button class="btn btn-danger float-left clearfix" type="button">
            <i class="mr-2 fas fa-times text-white"></i>Sözleşmeyi Sil</button>
          <button class="btn btn-secondary float-right" type="button" data-dismiss="modal">Kapat</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'ContractPopupPage',
  props: {
    contractId: Number
  },
  data() {
    return {
      contractModel: {},
    }
  },
  computed: { 
    getPersonelId: function() { return this.$store.getters.getPersonelId; },
    getPersonelName: function() { return this.$store.getters.getPersonelName; },
    getSessionId: function() { return this.$store.getters.getSessionId; },
  },
  methods: {
    async getContractById(id) {
      this.$wait.start('contract-detail-loading')
      axios.get('/api/a1/contract-byid?sessionId=' + this.getSessionId + "&contractId=" + id)
      .then(response => {
        this.contractModel = response.data[0]
        console.log(this.contractModel.Vehicles)
        this.$wait.end('contract-detail-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('contract-detail-loading')
      })
    },
    async getContractVehicles(id) {
      axios.get('/api/a1/contract-vehicles?sessionId=' + this.getSessionId + "&contractId=" + id)
      .then(response => {
        this.contractModel.Vehicles = response.data
      })
      .catch(error => {
        console.log(error)
      })

      console.log(this.contractModel.Vehicles)
    },
    async getContractInvioces(id) {
      axios.get('/api/a1/contract-invoices?sessionId=' + this.getSessionId + "&contractId=" + id)
      .then(response => {
        this.contractModel.Invoices = response.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    showInvoiceDetails(index) {
      if(index > -1) {
        let im = this.contractModel.Invoices[index];
        this.$parent.$refs.invoicePopup.setInvoiceData(im.Id, im)
      }
      
      $("#modalInvoicePopup").modal('show');
    }
  },
  mounted() {
    moment.locale('tr')
  }
}

</script>
<style scoped>
  .nav-tabs .nav-item { color: #000 !important; opacity: 1; margin-right: 4px;}
  .nav-tabs .nav-item:last-child { margin-right: 0; }
  .nav-tabs .nav-item .nav-link { color: #000 !important; opacity: 1; font-weight: 500; background-color: #F9F9F9; border-color: #e0e0e0; }
  .nav-tabs .nav-item .nav-link.active { background-color: #343A40 !important; color: #F0F0F0 !important; border-color: #343A40;}
  .nav-tabs, .tab-content { margin-right: -5px; margin-left: -5px; }
  .tab-content { padding-top: 0; }
  table, .dropdown-item { font-size: .875rem; }
</style>


// WEBPACK FOOTER //
// src/partials/ContractPopupPage.vue